import angular from 'angular';

function RevenueDataService() {
    const getRevenuesFromResponseData = ({ result: responseData }) => {
        const { revenues } = (responseData || []).find(({ revenues }) => revenues);

        return revenues;
    };

    return {
        getRevenuesFromResponseData,
    };
}

angular.module('TALENYA-FE').factory('RevenueDataService', RevenueDataService);
